import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { Primitive } from 'reka-ui'
import { cn } from '@/lib/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuSubButton',
  props: {
    asChild: { type: Boolean },
    as: { default: 'a' },
    size: { default: 'md' },
    isActive: { type: Boolean },
    class: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), {
    "data-slot": "sidebar-menu-sub-button",
    "data-sidebar": "menu-sub-button",
    as: _ctx.as,
    "as-child": _ctx.asChild,
    "data-size": _ctx.size,
    "data-active": _ctx.isActive,
    class: _normalizeClass(
      _unref(cn)(
        'text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
        'data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground',
        _ctx.size === 'sm' && 'text-xs',
        _ctx.size === 'md' && 'text-sm',
        'group-data-[collapsible=icon]:hidden',
        props.class
      )
    )
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "as-child", "data-size", "data-active", "class"]))
}
}

})